export default __webpack_public_path__ + "static/media/hinditextnew.9d028a42.png";